import type { FeaturePurchaseOfferDefinition } from "@slot/game-shell";

/**
 * The bonus buys (their ids are the server contract: they ride `SpinRequest.requestedFeatureIdentifier` verbatim):
 * each buys straight into Hold & Win with its boosters. Their prices are the operator's
 * (`initialSettings.featurePriceMultipliersById`; offline, `sim/offlineMath.ts` BONUS_BUYS); an offer without a
 * positive one is dropped by the shell.
 */
export function createFeaturePurchaseOffers(): FeaturePurchaseOfferDefinition[] {
  return [
    {
      id: "bonus_random",
      actionType: "bonus_buy",
      titleKey: "feature_purchase.bonus_random.title",
      descriptionKey: "feature_purchase.bonus_random.description",
      fallbackTitle: "Random Boost",
      fallbackDescription: "Start Hold & Win with 1 to 3 random boosters.",
      iconPath: "feature-purchase/icons/random",
    },
    {
      id: "bonus_trio",
      actionType: "bonus_buy",
      titleKey: "feature_purchase.bonus_trio.title",
      descriptionKey: "feature_purchase.bonus_trio.description",
      fallbackTitle: "Booster Trio",
      fallbackDescription: "Start Hold & Win with LIFE, MULTI and GROW.",
      iconPath: "feature-purchase/icons/trio",
    },
    {
      id: "bonus_madness",
      actionType: "bonus_buy",
      titleKey: "feature_purchase.bonus_madness.title",
      descriptionKey: "feature_purchase.bonus_madness.description",
      fallbackTitle: "Multi Madness",
      fallbackDescription: "All three boosters, and MULTI erupts on every respin.",
      iconPath: "feature-purchase/icons/madness",
    },
  ];
}
